// Función para detectar el tipo de pantalla del usuario desde JS
function esDispositivoMovilOTablet() {
    return window.matchMedia("(max-width: 768px)").matches;
}
window.esDispositivoMovilOTablet = esDispositivoMovilOTablet;

/**
 * Código encargado de animar el sitio web
 */
document.addEventListener('DOMContentLoaded', () => {
    // Configuración del IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible'); // Activa la animación
                observer.unobserve(entry.target); // Deja de observar una vez activado
            }
        });
    });

    // Selecciona los elementos con la clase .animate-on-scroll
    document.querySelectorAll('.static-animate-on-scroll').forEach(el => observer.observe(el));
});
